export const invoicesRoutes = {
  app: {
    getInvoices: '/app/invoices',
    getArchivedInvoices: '/app/archived-invoices',
    getCurrentInvoicesCSV: '/app/invoices/export',
    downloadCurrentInvoice: '/app/invoices/:id/download',
    downloadArchivedInvoice: '/app/archived-invoices/:id/download',
  },
  internal: {
    chargeInvoice: '/internal/invoices/:id/charge',
    getInvoices: '/internal/invoices',
    getInvoicesCSV: '/internal/invoices/export',
    getInvoicesSalesCampaigns: '/internal/invoices/:id/update',
    getArchivedInvoices: '/internal/archived-invoices',
    updateInvoiceStatus: '/internal/invoices/:id',
    downloadCurrentInvoice: '/internal/invoices/:id/download',
    downloadArchivedInvoice: '/internal/archived-invoices/:id/download',
  },
};
